<div class="d-center">
    <p-progressSpinner [hidden]="!skelition"></p-progressSpinner>
</div>
<app-no-data *ngIf="!skelition && !courseData"></app-no-data>

<div class="container-fluid" *ngIf="!!courseData">
    <form #courseForm="ngForm" (ngSubmit)="saveData(courseForm)">
        <div class="custom-nav">
            <div class="">
                <div class="row">
                    <div>
                        <div class="w-100">
                            <h4>
                                <i class="fa-solid fa-arrows-rotate v4-ml-2"></i>{{ "Recreate" | translator }}
                            </h4>
                            <div class="w-100">
                                <label class="label-ui">{{'Course title'|translator}}</label>
                                <input [required]="true" class="w-100" name="title" [(ngModel)]="courseData.title"
                                    pInputText />
                                <div class="error-text" *ngIf="validateFormField(courseForm,'title')">
                                    {{'The title is required' | translator}}
                                </div>
                            </div>
                            <div class="w-100">
                                <label class="label-ui">{{'The description :'|translator}}</label>
                                <textarea type="text" [required]="true" class="w-100" name="description"
                                    [(ngModel)]="courseData.description" pInputText></textarea>
                                <div class="error-text" *ngIf="validateFormField(courseForm,'description')">
                                    {{'Description is required' | translator}}
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <label class="label-ui">{{'Start Date'|translator}}</label>
                                    <p-calendar #start [minDate]="today"
                                        (ngModelChange)="validateDates($event,courseData.end_date)" [required]="true"
                                        name="start_date" [(ngModel)]="courseData.start_date">
                                        <ng-template pTemplate="date" let-date>
                                            <span [ngStyle]="{
                                                textDecoration: disableCourseDates(date,'START')
                                                  ? 'line-through'
                                                  : 'inherit'
                                              }">{{ date.day }}</span>
                                        </ng-template>
                                    </p-calendar>
                                    <div class="error-text" *ngIf="validateFormField(courseForm,'start_date')">
                                        {{'Start Date required' | translator}}
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <label class="label-ui">{{'End Date'|translator}}</label>
                                    <p-calendar [minDate]="courseData.start_date"
                                        (ngModelChange)="validateDates(courseData.start_date,$event)" [required]="true"
                                        name="end_date" [(ngModel)]="courseData.end_date">
                                        <ng-template pTemplate="date" let-date>
                                            <span [ngStyle]="{
                                                textDecoration: disableCourseDates(date,'END')
                                                  ? 'line-through'
                                                  : 'inherit'
                                              }">{{ date.day }}</span>
                                        </ng-template>
                                    </p-calendar>
                                    <div class="error-text" *ngIf="validateFormField(courseForm,'end_date')">
                                        {{'End Date required' | translator}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="w-100">
                <div>
                    <h5 class=" mt-3">{{'Sessions'|translator}}</h5>
                    <div *ngFor="let session of sessions;let i=index" class="w-100 mt-2">
                        <h5 style="margin:.7rem 0 -.3rem 0">{{session.title}}</h5>
                        <div class="">
                            <div class="row">
                                <div class="col-md-12 col-12">
                                    <label class="label-ui">{{'Date'|translator}}</label>
                                    <p-calendar (ngModelChange)="resetTrainer($event,'DATE',i)"
                                        [disabled]="!courseData.start_date || !courseData.end_date" [required]="true"
                                        name="date_{{i}}" [minDate]="courseData.start_date"
                                        [maxDate]="courseData.end_date" [(ngModel)]="session.date">
                                        <ng-template pTemplate="date" let-date>
                                            <span [ngStyle]="{
                                                textDecoration: disableDates(date)
                                                  ? 'line-through'
                                                  : 'inherit'
                                              }">{{ date.day }}</span>
                                        </ng-template>
                                    </p-calendar>
                                    <div class="error-text" *ngIf="validateFormField(courseForm,'date_' + i)">
                                        {{'Date is Required' | translator}}
                                    </div>
                                    <div class="error-text" *ngIf="!courseData.start_date || !courseData.end_date">
                                        {{'start and end date required' | translator}}
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <label class="label-ui">{{'Start time:' | translator}}</label>
                                    <input (ngModelChange)="resetTrainer($event,'STIME',i)" [required]="true" name="start_time_{{i}}"
                                        type="time" [(ngModel)]="session.start_time" pInputText class="w-100" />
                                    <div class="error-text" *ngIf="validateFormField(courseForm,'start_time_'+i)">
                                        {{'start time is required' | translator}}
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <label class="label-ui">{{'End time :' | translator}}</label>
                                    <input (ngModelChange)="resetTrainer($event,'ETIME',i)" [required]="true" name="end_time_{{i}}"
                                        type="time" [(ngModel)]="session.end_time" pInputText class="w-100" />
                                    <div class="error-text" *ngIf="validateFormField(courseForm,'end_time_' + i)">
                                        {{'end time is required' | translator}}
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="session?.trainer?.name" class="col-lg-12 col-md-12 col-12 mb-3">
                                <label class="label-ui" for="trainer"><i
                                        class="fa fa-chalkboard-user ml-2 mr-2 result-icons"></i>
                                    {{ "the coach" | translator }}&nbsp;:&nbsp;</label>
                                <div class="d-flex justify-content-between">
                                    <h5>{{ session?.trainer?.name }}</h5>
                                    <button class="v4-btn-every py-2" (click)="updateTrainerSection($event, session)">
                                        <i class="pi pi-edit v4-ml-2 v4-sstarabic">{{
                                            "update trainer" | translator
                                            }}</i>
                                    </button>
                                </div>
                            </div>

                            <div class="w-100" *ngIf="!session?.trainer?.name;">
                                <label class="block v4-color-white font-medium mb-2 font-bold" for="description">
                                    {{ "Select Master Trainer" | translator }}
                                </label>
                                <div class="row d-flex align-items-center">
                                    <div class="col-md-6 col-12">
                                        <p-dropdown styleClass="w-100"
                                            [options]="showInternal ? internalTrainers : externalTrainers"
                                            [(ngModel)]="session.trainer" optionLabel="name" appendTo="body"
                                            (onChange)="checkTrainerAvailability(session)" [filter]="true"
                                            filterBy="name" name="trainer_{{i}}" [showClear]="false"
                                            placeholder="{{ 'Choose the coach' | translator }}">
                                            <ng-template let-trainers pTemplate="item">
                                                <div class="flex align-items-center gap-2">
                                                    <div>{{ trainers.name }}</div>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                        <div class="error-text" *ngIf="validateFormField(courseForm,'trainer_' + i)">
                                            <div>{{ "Trainer required" | translator }}</div>
                                        </div>
                                        <div class="error-text" *ngIf="trainerErrors.customError">
                                            <div>
                                                {{ "Trainer is not available at this time" | translator }}
                                            </div>
                                        </div>
                                        <div class="error-text" *ngIf="trainerErrors.requestError">
                                            <div>
                                                {{
                                                "Please provide session date and time to assign trainer"
                                                | translator
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        <p-toggleButton class="v4-ptog-btn" styleClass="w-100"
                                            onLabel="{{ 'External' | translator }}"
                                            (onChange)="internalExternal($event)"
                                            offLabel="{{ 'Internal' | translator }}"></p-toggleButton>
                                    </div>
                                    <div class="col-md-3 col-6"  *ngIf="hasPermission('TRAINER','c')">
                                        <button class="w-100 v4-btn-every py-2" (click)="addTrainerModal = true">
                                            <i class="pi pi-plus v4-ml-2"></i>{{ "Add trainer" | translator }}
                                        </button>
                                    </div>
                                    <!-- <div style="width: 10%;">
                                        <i pTooltip="{{'Update Trainer' | translator }}" tooltipPosition="top"
                                            (click)="updateTrainerSection($event)" class="fa fa-times py-1 cross-btnn"></i>
                                    </div> -->
                                </div>
                            </div>


                            <div class="row">
                                <ng-container *ngIf="session.sessionType == 'Online'">
                                    <div class="col-md-12 col-12">
                                        <label class="label-ui">{{'Link' | translator}}</label>
                                        <input [required]="true" name="zoom_url_{{i}}" type="text"
                                            [(ngModel)]="session.zoom_url" pInputText class="w-100" />
                                        <div class="error-text" *ngIf="validateFormField(courseForm,'zoom_url_' + i)">
                                            {{'Session Url is Required' | translator}}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="session.sessionType == 'Onsite'">
                                    <div class="col-md-6 col-12">
                                        <label class="label-ui">{{'Headquarters address' | translator}}</label>
                                        <input [required]="true" name="address_{{i}}" type="text"
                                            [(ngModel)]="session.address" pInputText class="w-100" />
                                        <div class="error-text" *ngIf="validateFormField(courseForm,'address_' + i)">
                                            {{'Address Required' | translator}}
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <label class="label-ui">{{'Location Link' | translator}}</label>
                                        <input [required]="true" name="locationLink_{{i}}" type="text"
                                            [(ngModel)]="session.locationLink" pInputText class="w-100" />
                                        <div class="error-text"
                                            *ngIf="validateFormField(courseForm,'locationLink_' + i)">
                                            {{'Link required' | translator}}
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-12">
                                        <label class="label-ui">{{'City' | translator}}</label>
                                        <p-dropdown [required]="true" name="city_{{i}}" id="city" [filter]="true"
                                            filterBy="label" [options]="locations"
                                            placeholder="{{ 'Choose the city' | translator }}"
                                            [(ngModel)]="session.city" styleClass=" sstarabic w-100"
                                            class="w-100">
                                            <ng-template let-item pTemplate="item">
                                                <i [ngClass]="item.icon"></i>
                                                {{ item.label }}
                                            </ng-template>
                                        </p-dropdown>
                                        <div class="error-text" *ngIf="validateFormField(courseForm,'city_' + i)">
                                            {{'city required' | translator}}
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="my-4 w-100">
                    <button type="submit" class="v4-btn-every py-2 w-100"><i
                            class="pi pi-check v4-ml-2"></i>{{'Save'|translator}}</button>
                    <div class="error-text" *ngIf="courseForm.submitted && !courseForm.valid">
                        {{'Please fill in the missing details for your account' | translator}}
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Add Trainer' | translator }}"
    [(visible)]="addTrainerModal" [style]="{ margin: '0rem 1rem', width: '70vw' }" [maximizable]="true">
    <ng-container *ngIf="!showInternal; else addInternalTrainer">
        <app-add-external-user *ngIf="addTrainerModal" [addCompany]="true" (updatedData)="handleUpdatedUserData($event)"
          [type]="'CREATE'" [ExternalType]="'trainer'"></app-add-external-user>
      </ng-container>
     <ng-template #addInternalTrainer>
      <app-assign-users [userFetchUrl]="'user/get'" [selectionData]="[]" (selectedUsersList)="assNewTrainers($event)"
        [query]="{
          'externalUser.status': { $ne: true },
          'externalUser.role': { $nin: ['trainer', 'coordinator'] }
        }" *ngIf="showInternal">
      </app-assign-users>
     </ng-template>
    

<p-toast></p-toast>